import { ICategoryListItem } from '../../../services/api/client/index';
import { IAction, KEEP_THE_SAME, StateStatus } from 'redux/utils/common';
import {
  IAgent,
  IClientListItem,
  IRole,
  ICustomersMiniProfileData,
} from 'services/api/client';
import * as Types from './types';
import { LanguagesEnum } from 'constants/languages';
import { IBlogsListOutput } from 'services/api/blogs';

export interface IState {
  blogsList: {
    status: StateStatus | null;
    data: IBlogsListOutput | null;
  };
  latestNews: {
    status: StateStatus | null;
    data: IBlogsListOutput | null;
  };
  updateBlog: {
    status: StateStatus | null;
  };
  deleteBlog: {
    status: StateStatus | null;
  };
}

const initialState: IState = {
  blogsList: {
    status: null,
    data: null,
  },
  latestNews: {
    status: null,
    data: null,
  },
  updateBlog: {
    status: null,
  },
  deleteBlog: {
    status: null,
  },
};

const BlogsShowReducer = (
  state: IState = initialState,
  action: IAction
): IState => {
  switch (action.type) {
    case Types.SET_BLOGS_SHOW_LIST:
      return {
        ...state,
        blogsList: {
          ...state.blogsList,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.SET_LATEST_NEWS:
      return {
        ...state,
        latestNews: {
          ...state.latestNews,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.UPDATE_BLOG:
      return {
        ...state,
        updateBlog: {
          status: action.status || null,
        },
      };
    case Types.DELETE_BLOG:
      return {
        ...state,
        deleteBlog: {
          status: action.status || null,
        },
      };
    default:
      return {
        ...state,
      };
  }
};

export default BlogsShowReducer;
